// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.note-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.note-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

/* START: Updated header styles */
.note-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1.5rem;
}
.note-header .note-header-data {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

/* END: Updated header styles */
.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  /* margin-right: 1.5rem; // Removed */
  text-transform: uppercase;
}

.note-title h2 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-dark);
  font-weight: 600;
}

/* START: Added client-actions styles */
.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* END: Added client-actions styles */
.note-tag {
  display: inline-block;
  margin-top: 0.5rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  cursor: pointer;
}

.note-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.detail-item .icon {
  font-size: 1.25rem;
  color: var(--primary-color);
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.detail-item label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--text-light);
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.detail-item p {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--text-dark);
}

.note-description {
  font-size: 0.95rem;
  color: var(--text-medium);
  margin-bottom: 1rem;
  line-height: 1.6;
}

.note-document a {
  font-weight: 500;
  color: var(--primary-color);
  text-decoration: underline;
}
.note-document a:hover {
  text-decoration: none;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

.error-message {
  text-align: center;
  color: var(--danger-color);
  font-weight: 500;
  font-size: 1rem;
  padding: 2rem;
  width: 100%;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .note-detail-container {
    padding: 1rem;
  }
  .note-card {
    padding: 1.5rem;
  }
  .note-details-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewNote/ViewNote.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAEA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA,iCAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AAEA,+BAAA;AAEA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;AAAF;;AAIE;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AADJ;;AAKA,uCAAA;AACA;EACE,aAAA;EACA,YAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAFJ;AAII;EACE,yCAAA;EACA,2BAAA;EACA,sCAAA;AAFN;AAIM;EACE,YAAA;EACA,2BAAA;AAFR;AAMI;EACE,wCAAA;EACA,0BAAA;EACA,qCAAA;AAJN;AAMM;EACE,YAAA;EACA,2BAAA;AAJR;;AASA,qCAAA;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;AAPF;;AAUA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,qBAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAPF;AASE;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;AARJ;AAWE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAVF;;AAcE;EACE,gBAAA;EACA,2BAAA;EACA,0BAAA;AAXJ;AAYI;EACE,qBAAA;AAVN;;AAeA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAZF;;AAeA;EACE;IACE,yBAAA;EAZF;AACF;AAeA;EACE;IACE,aAAA;EAbF;EAgBA;IACE,eAAA;EAdF;EAiBA;IACE,0BAAA;EAfF;AACF","sourcesContent":[":root {\n  --primary-light: #eef2ff;\n  --success-color: #10b981;\n  --danger-color: #ef4444;\n  --text-dark: #1f2937;\n  --text-medium: #4b5563;\n  --text-light: #9ca3af;\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --border-radius: 12px;\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  --transition: all 0.3s ease;\n}\n\n.note-detail-container {\n  padding: 1rem;\n  background-color: #f4f6f8;\n  display: flex;\n}\n\n.note-card {\n  background-color: var(--card-bg);\n  border-radius: var(--border-radius-primary);\n  box-shadow: var(--box-shadow);\n  width: 100%;\n  padding: 2rem;\n}\n\n/* START: Updated header styles */\n.note-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 1.5rem;\n\n  .note-header-data {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n  }\n}\n/* END: Updated header styles */\n\n.avatar {\n  width: 64px;\n  height: 64px;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  font-weight: bold;\n  /* margin-right: 1.5rem; // Removed */\n  text-transform: uppercase;\n}\n\n.note-title {\n  h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: var(--text-dark);\n    font-weight: 600;\n  }\n}\n\n/* START: Added client-actions styles */\n.client-actions {\n  display: flex;\n  gap: 0.75rem;\n  \n  button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: all 0.2s;\n    \n    &.btn-update {\n      background-color: var(--primary-light-bg);\n      color: var(--primary-color);\n      border: 1px solid var(--primary-color);\n      \n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n    }\n    \n    &.btn-delete {\n      background-color: var(--danger-light-bg);\n      color: var(--danger-color);\n      border: 1px solid var(--danger-color);\n      \n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n    }\n  }\n}\n/* END: Added client-actions styles */\n\n.note-tag {\n  display: inline-block;\n  margin-top: 0.5rem;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.note-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.detail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n\n  .icon {\n    font-size: 1.25rem;\n    color: var(--primary-color);\n    margin-top: 0.25rem;\n    flex-shrink: 0;\n  }\n\n  label {\n    display: block;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    color: var(--text-light);\n    letter-spacing: 0.5px;\n    margin-bottom: 0.25rem;\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: var(--text-dark);\n  }\n}\n\n.note-description {\n  font-size: 0.95rem;\n  color: var(--text-medium);\n  margin-bottom: 1rem;\n  line-height: 1.6;\n}\n\n.note-document {\n  a {\n    font-weight: 500;\n    color: var(--primary-color);\n    text-decoration: underline;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(67, 97, 238, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 2rem auto;\n}\n\n.error-message {\n  text-align: center;\n  color: var(--danger-color);\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 2rem;\n  width: 100%;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .note-detail-container {\n    padding: 1rem;\n  }\n\n  .note-card {\n    padding: 1.5rem;\n  }\n\n  .note-details-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
